module.exports = __webpack_public_path__ + "r-v3/img/ml_33_00.03655c15.jpg";